import React from "react";
import {connect} from "react-redux";
import {Dialog, Button, Typography, TextField, Box, Paper} from "@material-ui/core";
import {Clear} from '@material-ui/icons';
import {IStore} from "../store/reducers";
import actionTypes from "../store/actionTypes";
import axios from "axios";
import {userService} from "../services/UserService";
import config from '../config.json';
import {INotificacion, IParcela} from "../types";
import UnnamedImage from "../icons/PNGs/unnamed.png";

import DateUtils from "@date-io/moment";
import { MuiPickersUtilsProvider, DatePicker, KeyboardDateTimePicker} from "@material-ui/pickers";
import {Brush, CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";



interface IProps {
    close(): void
    notify(notification: INotificacion): void
    data: Record<string, any>
    sensores: Record<string, any>[]
}

interface IState {
    fullData: Record<string, any>
    selectedSensor: string
}

type ReadType = {
    date: string,
    value: number
}

class EstacionSensores extends React.Component<IProps, IState>{

    state:IState = {
        fullData: {} as Record<string, any>,
        selectedSensor: ""
    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        if (Object.keys(nextProps.data).length > 0 && Object.keys(this.props.data).length === 0) {
            axios.get(
                config.url+`/get/all/reads/by/station?station_id=${nextProps.data.id}`,
                {auth: {
                        username: `${userService.getUser()}`,
                        password: `${userService.getPass()}`
                    }})
                .then((res: { data: Record<string, ReadType[]> }) => {

                    const fullData: Record<string, any> = {}
                    let firstSensorName = ""
                    for (const sensorId in res.data) {
                        const sensor = this.props.sensores.filter((sensor) => `${sensor.id}` === sensorId)[0]
                        const sensorName = sensor.name;
                        const units = sensor.units

                        if (firstSensorName.length === 0) {
                            firstSensorName = sensorName
                        }

                        fullData[sensorName] = {
                            units: units,
                            data: [] as any[]
                        }

                        for (const read of res.data[sensorId]) {
                            fullData[sensorName].data.push({
                                name: read.date.split(".")[0],
                                [sensorName]: read.value
                            })
                        }
                    }
                    this.setState({
                        fullData: fullData,
                        selectedSensor: firstSensorName
                    })
                })
                .catch(() => {})
        }
        return true
    }

    render() {
        return (
            <Dialog
                open={Object.keys(this.props.data).length !== 0}
                maxWidth={false}
                PaperProps={{style:
                        {
                            display: 'flex',
                            flexDirection: 'column',
                            height: '90vh',
                            width: '70vw',
                        }}}
            >
                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Poppins"
                />

                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-end",
                        width: "100%",
                        height: 60
                    }}
                >
                    <Button
                        variant="contained"
                        onClick={() => {this.props.close()}}
                    >
                        <Clear/>
                    </Button>

                </div>

                {Object.keys(this.state.fullData).length > 0 &&
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            width: "100%",
                            height: "90%"
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                width: 250
                            }}
                        >
                            {Object.keys(this.state.fullData).map((sensorName) =>
                                <Button
                                    variant={this.state.selectedSensor === sensorName? "contained" : "outlined"}
                                    style={{
                                        margin: 30
                                    }}
                                    onClick={() => this.setState({selectedSensor: sensorName})}
                                >
                                    {sensorName}
                                </Button>
                            )}
                        </div>

                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                width: "calc(100% - 310px)",
                                margin: 30
                            }}
                        >
                            <ResponsiveContainer
                                width="100%"
                                height="100%"
                            >
                                <LineChart
                                    data={this.state.fullData[this.state.selectedSensor].data}
                                    margin={{
                                        top: 40,
                                        right: 40,
                                        left: 40,
                                        bottom: 20,
                                    }}
                                >
                                    <CartesianGrid />
                                    <XAxis dataKey="name" angle={0} dy={5}/>
                                    <YAxis yAxisId="left" label={{ value: this.state.fullData[this.state.selectedSensor].units, angle: -90, position: 'Left', fontSize: 24, dx:-20, fontFamily: "Poppins"}} />
                                    <Tooltip/>
                                    <Line
                                        yAxisId="left"
                                        type="monotone"
                                        dataKey={this.state.selectedSensor}
                                        stroke="#288CC6"
                                        strokeWidth={3}
                                    />
                                    <Brush
                                        height={30}
                                        stroke="#4C494B"
                                        startIndex={(this.state.fullData[this.state.selectedSensor].data).length - 50}
                                        endIndex={(this.state.fullData[this.state.selectedSensor].data).length - 1}
                                        dataKey="name"
                                    />
                                </LineChart>
                            </ResponsiveContainer>
                        </div>

                    </div>
                }

            </Dialog>
        )
    }
}

const mapStateToProps = (state: IStore) => ({
    data: state.navegacion.dialogs.estacion_sensores,
    sensores: state.principal.sensores,
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    close: () => dispatch({type: "open-estacion-sensores-dialog", callback: {} as Record<string, any>}),
    notify: (notification: INotificacion) => dispatch({type: 'notify', notification})
});

export default connect(mapStateToProps, mapDispatchToProps)(EstacionSensores);